import Button from 'apollo-react/components/Button';

const ButtonCustom = (props) => {
    // icon must be from apollo-react-icons
    const { text, color, onClick, icon, status, style } = props;
    return (
        <Button {...props} size="small" onClick={onClick} variant={color} icon={icon} status={status}
        style={{ fontFamily: 'Proxima Nova', fontWeight: 600, fontSize:16,...style}} >
            {text}
        </Button>
    )
}

export default ButtonCustom;